export interface FeatureTooltipConfig {
  key: string;
  message: string;
}

export const FEATURE_TOOLTIPS: Record<string, FeatureTooltipConfig> = {
  timer: {
    key: 'user_seen_timer_tooltip',
    message: 'Visual Timers help show how much time is left for an activity.\n\nExample: set a 5-minute timer for brushing teeth or cleaning up toys.',
  },
  schedule: {
    key: 'user_seen_schedule_tooltip',
    message: 'Picture Schedules help break routines into clear visual steps.\n\nExample: a morning routine with steps like Wake Up → Get Dressed → Brush Teeth → Eat Breakfast.',
  },
  choiceboard: {
    key: 'user_seen_choiceboard_tooltip',
    message: 'Choice Boards help individuals make decisions.\n\nExample: choosing between snacks, activities, or weekend plans.',
  },
  narrative: {
    key: 'user_seen_narrative_tooltip',
    message: 'Social Narratives explain situations using simple stories.\n\nExample: preparing for a doctor visit or learning how to take turns.',
  },
  video: {
    key: 'user_seen_video_tooltip',
    message: 'Video Models demonstrate how to complete a task.\n\nExample: watching a short video showing how to wash hands or pack a backpack.',
  },
  reminder: {
    key: 'user_seen_reminder_tooltip',
    message: "Reminders notify users when it's time for important activities.\n\nExample: medication, homework time, or getting ready for bed.",
  },
  location: {
    key: 'user_seen_location_tooltip',
    message: 'Location Preparation helps individuals become familiar with new places.\n\nExample: previewing photos of a dentist office or a new school.',
  },
  reward: {
    key: 'user_seen_reward_tooltip',
    message: 'Reward Charts reinforce positive behavior.\n\nExample: earning stars for completing a bedtime routine or finishing homework.',
  },
  messenger: {
    key: 'user_seen_messenger_tooltip',
    message: 'Messenger lets caregivers and collaborators communicate with each other.',
  },
  progress: {
    key: 'user_seen_progress_tooltip',
    message: 'Track progress toward goals and objectives here.\n\nYou can also create new plans using Plan with AI.',
  },
  location_boards: {
    key: 'user_seen_location_boards_tooltip',
    message: 'ShowMe can suggest choice boards based on your location while the app is open.\n\nLocation features only work while your browser tab is active — they cannot track you in the background.',
  },
};
